import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { CreditReviewNotes } from './credit-review-notes.entity';

export class CreateCreditReviewNotesDto extends Omit(CreditReviewNotes, BaseEntityFieldsArray, []) {}
